import { AuthLayout } from 'views/layouts'
import ForgotFormContainer from '../../containers/Forms/Forgot'

const Forgot = () => {
  return (
    <AuthLayout>
      <ForgotFormContainer />
    </AuthLayout>
  )
}

export default Forgot
